import Component from '../abstracts/Component';
import Cookies from 'js-cookie';

/**
 Chat component
 */
export default class ChatComponent extends Component {
  constructor() {
    super();
    this.personalStylistPopUpTriggerTime = document.querySelector(this.SELECTORS.personalStylistPopUpTriggerTime).value.replace('.', '');
    this.personalStylistBanner = document.querySelector(this.SELECTORS.personalStylistBanner);
    this.chatEnabled = document.querySelector(this.SELECTORS.chatEnabled).value;
    this.personalStylistCloseBtn = document.querySelector(this.SELECTORS.personalStylistCloseBtn);
  }

  // common selectors, overridable
  get SELECTORS() {
    return {
      //miaw chat enabled
      chatEnabled: '#chatEnabled',
      // PS ?
      personalStylistPopUpTriggerTime: '#personalStylistPopUpTriggerTime',
      personalStylistBanner: '.live-chat-personal-stylist-cta',
      personalStylistStartChat: '.live-chat-personal-stylist-cta .start-chat',
      personalStylistCloseBtn: '.live-chat-personal-stylist-cta .icon-close',
      hidePersonalStylistForPage: 'data-hide-personal-stylist',
      // extra link chat
      startChatLink: '[data-name=live-chat] a',
      chatBallon: '.embedded-messaging'
    };
  }

  // display PS button
  setupPersonalStylistDelayedPopup() {
    let isPSCookieSet = Cookies.get('hidePSBanner');
    // click start chat button
    if (this.personalStylistBanner != null && isPSCookieSet != 'true') {
      setTimeout(() => {
        const isChatBalloonDisplayed = document.querySelector(this.SELECTORS.chatBallon);
        if (isChatBalloonDisplayed) {
          document
            .querySelector('.live-chat-personal-stylist-cta')
            .classList.remove('hidden');
        }
      }, this.personalStylistPopUpTriggerTime);
    }
  }

  hidePersonalStylistBanner() {
    // hide banner/button
    document
      .querySelector('.live-chat-personal-stylist-cta')
      .classList.add('hidden');
    Cookies.set('hidePSBanner', 'true');
  }

  render() {
    this.log('rendering...');

    // check if new chat is enabled
    // if is enabled let's launch PS
    if (this.chatEnabled == 'true') {
      this.setupPersonalStylistDelayedPopup();
      this.personalStylistCloseBtn.addEventListener('click', () => {
        this.hidePersonalStylistBanner();
      });
    }
  }
}
